export const tradeLabel = (name) => ({
  stockTrader: "Interlink Trading",
  coinFlip: "CryptoInterlink Coin",
  lottery: "Lottery",
}[name] || "Trade");
